// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 1, // Store Custom Code
    },
    /* Store Custom Code - Start */
    cookies: {
        showChangeCustomerPageVariant: "showChangeCustomerPageVariant",
        sideColumnLayoutCollapsed: "sideColumnLayoutCollapsed",
    },
    pageType: {
        orderChangeRequest: "OrderChangeRequestPage",
        orderChangeRequestReview: "ReviewOrderChangeRequestPage",
        salesSupport: "SalesSupportPage",
        shippingSupport: "ShippingSupportPage",
        taxExemptionCertificates: "TaxExemptionCertificatesPage",
        tecContactSupport: "TECContactSupportPage",
        tecSubmitNew: "TECSubmitNewPage",
        myReports: "MyReportsPage",
        report: "ReportPage",
        featureNotes: "FeatureNotesPage",
        featureNotesList: "FeatureNotesListPage",
        resetPassword: "ResetPasswordPage",
        inviteYourColleague: "InviteYourColleaguePage",
        recommendedProductRequest: "RecommendedProductRequestPage",
        alternatePackagingPage: "AlternatePackagingPage",
        instructionVideos: "InstructionVideosPage",
        liveplants: "LivePlantsPage",
        shipmentHistory: "ShipmentHistoryPage",
        trailerTracking: "TrailerTrackingPage",
        notificationPreferences: "NotificationPreferencesPage",
        orderComplaint: "OrderComplaintPage",
        packagingAdvice: "PackagingAdvicePage",
        simpleQuote: "SimpleQuotePage",
        accountApplicationCredit: "AccountApplicationCreditPage",
    },
    widgetGroup: {
        contactUsTopics: "Contact Us Topics" as any,
        orderChangeRequest: "Order Change Request" as any,
        orderChangeRequestReview: "Review Order Change Request" as any,
        orderComplaint: "Order Complaint" as any,
        taxExemptionCertificates: "TEC" as any,
        tecContactSupport: "TEC Contact Support" as any,
        tecSubmitNew: "TEC Submit New" as any,
        myReports: "My Reports" as any,
        report: "Report" as any,
        featureNotes: "Feature Notes" as any,
        featureNotesList: "Feature Notes List" as any,
        resetPassword: "Reset Password" as any,
        inviteYourColleague: "InviteYourColleaguePage" as any,
        recommendedProductRequest: "Recommended Product Request" as any,
        alternatePackaging: "Product Alternate Packaging" as any,
        shipmentHistory: "Shipment History" as any,
        trailerTracking: "Trailer Tracking" as any,
        notificationPreferences: "Notification Preferences" as any,
        simpleQuote: "Simple Quote" as any,
        packagingAdvice: "Packaging Advice" as any,
        productDetails: "Product Details" as any,
        orderInformation: "Order Information" as any,
        accountApplication: "Account Application" as any,
        maintenance: "Maintenance" as any,
    },
    fileType: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    systemLists: {
        shipmentStatus: "Shipment Status",
    },
    shipToSequences: {
        showAll: "-1",
    },
    locations: {
        showAll: "-1",
    },
    regexPatterns: {
        email: /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi,
    },
    storage: {
        shipToHasChanged: "shipToHasChanged",
    },
    queryStringParameters: {
        referenceProductId: "referenceProductId",
    },
    maxPayloadSizeInBytes: 5 * 1024 * 1024, // 5 MB
    /** These entries should be translated before use (e.g.: array.map(x => translate(`${x}`))) */
    progressSteps: {
        orderChangeRequest: ["Change Order", "Review Changes", "Request Submitted"],
        checkout: ["Cart", "Review Order Details", "Order Submitted"],
    },
    logoPath: "/userfiles/greif-plus-logo.svg",
    /* Store Custom Code - End */
});
